export default __webpack_public_path__ + "total-records-light-icon.svg";